import { render, staticRenderFns } from "./safe4_track_alarm.vue?vue&type=template&id=901afb88&scoped=true"
import script from "./safe4_track_alarm.vue?vue&type=script&lang=js"
export * from "./safe4_track_alarm.vue?vue&type=script&lang=js"
import style0 from "./safe4_track_alarm.vue?vue&type=style&index=0&id=901afb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901afb88",
  null
  
)

export default component.exports